import { Injectable } from '@angular/core';
import { FeatureFlagService } from '@core/feature-flag.service';
import { UserService } from '@core/user.service';
import { FeatureFlagType } from '@shared/enums/feature-flag-type';
import { RoleType } from '@shared/enums/role-type';

@Injectable({
  providedIn: 'root',
})
export class ZbPortalRedesignHelpers {
  isZbPortal2024Active(): boolean {
    if (this.userService.user?.isViewingAsRole(RoleType.Student)) {
      return this.featureFlagService.isActive(FeatureFlagType.ZBPortal2024)
        && this.featureFlagService.isActive(FeatureFlagType.ZBStudentPortal2024);
    }
    return this.featureFlagService.isActive(FeatureFlagType.ZBPortal2024);
  }

  isZbPortal0801Active(): boolean {
    return this.featureFlagService.isActive(FeatureFlagType.ZBPortal0801);
  }

  isZbPortal0901Active(): boolean {
    return this.featureFlagService.isActive(FeatureFlagType.ZBPortal0901);
  }

  isZBParentPortal2026Active(): boolean {
    return this.featureFlagService.isActive(FeatureFlagType.ZBParentPortal2026);
  }

  constructor(
    private featureFlagService: FeatureFlagService,
    private userService: UserService
  ) {}
}
